import React from 'react';
import { Arr } from '../shared/SvgHelpers';

export default function Diagram8DWorkflow() {
  const steps = [
    { id: 'D0', label: 'Erfassung', color: '#2563eb', detail: 'Kunde, Produkt,\nProblem, Anhange', ki: 'E-Mail-\nExtraktion', gate: 'Kunde +\nProdukt' },
    { id: 'D1', label: 'Team', color: '#4f46e5', detail: 'Verantwortliche,\nTeam-Mitglieder', ki: null, gate: 'Min. 1\nMitglied' },
    { id: 'D2', label: 'Problem', color: '#7c3aed', detail: 'Fehlerbeschreibung,\nFehlercodes, Bilder', ki: 'Fehlercode-\nZuordnung', gate: 'Beschreibung\n+ Code' },
    { id: 'D3', label: 'Sofort', color: '#d97706', detail: 'Sofortmaßnahmen\n24-72 Stunden', ki: 'Maßnahmen-\nvorschläge', gate: 'Min. 1\nMaßnahme' },
    { id: 'D4', label: 'Ursache', color: '#dc2626', detail: '6M Ishikawa,\n5-Why Analyse', ki: 'KI-Ursachen-\nanalyse', gate: 'Min. 1\nUrsache' },
    { id: 'D5', label: 'Korrektur', color: '#16a34a', detail: 'Korrektur-Massn.\n7-30 Tage', ki: 'Maßnahmen-\nvorschläge', gate: 'Min. 1\nMaßnahme' },
    { id: 'D6', label: 'Wirksam', color: '#0891b2', detail: 'Wirksamkeits-\nprüfung', ki: null, gate: 'Prüfung\ndokumentiert' },
    { id: 'D7', label: 'Vorbeugung', color: '#7c3aed', detail: 'Präventive\nMaßnahmen', ki: null, gate: 'Min. 1\nMaßnahme' },
    { id: 'D8', label: 'Abschluss', color: '#16a34a', detail: 'Bewertung,\nPDF-Export', ki: 'Quality-\nScore', gate: 'Abschluss-\nbewertung' },
  ];
  const colW = 72, gap = 3, startX = 8;

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-bold text-green-700">3. 8D-Workflow -- Detaillierter Prozessablauf</h4>
      <p className="text-xs text-slate-500">Jeder D-Schritt mit Pflichtfeldern, Quality Gates und KI-Unterstutzung.</p>
      <svg viewBox="0 0 730 300" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        {/* Uberschriften-Zeile */}
        <text x={startX} y={18} fontSize="9" fontWeight="700" fill="#64748b">SCHRITT</text>
        <text x={startX} y={85} fontSize="9" fontWeight="700" fill="#64748b">INHALT</text>
        <text x={startX} y={160} fontSize="9" fontWeight="700" fill="#64748b">KI</text>
        <text x={startX} y={225} fontSize="9" fontWeight="700" fill="#64748b">QUALITY GATE</text>

        {steps.map((s, i) => {
          const x = startX + 50 + i * (colW + gap);
          return (
            <g key={s.id}>
              {/* D-Schritt Box */}
              <rect x={x} y={24} width={colW} height={40} rx={8} fill={s.color} opacity={0.12} stroke={s.color} strokeWidth={1.5} />
              <text x={x + colW / 2} y={42} textAnchor="middle" fontSize="14" fontWeight="800" fill={s.color}>{s.id}</text>
              <text x={x + colW / 2} y={56} textAnchor="middle" fontSize="9" fill="#475569">{s.label}</text>

              {/* Pfeil */}
              {i < 8 && <Arr x1={x + colW} y1={44} x2={x + colW + gap} y2={44} color={s.color} />}

              {/* Detail-Box */}
              <rect x={x} y={72} width={colW} height={48} rx={6} fill={s.color} opacity={0.04} stroke={s.color} strokeWidth={0.8} strokeDasharray="3,2" />
              {s.detail.split('\n').map((l, li) => (
                <text key={li} x={x + colW / 2} y={89 + li * 12} textAnchor="middle" fontSize="8" fill="#475569">{l}</text>
              ))}

              {/* KI-Box */}
              {s.ki ? (
                <g>
                  <rect x={x + 5} y={136} width={colW - 10} height={40} rx={20} fill="#7c3aed" opacity={0.08} stroke="#7c3aed" strokeWidth={1} />
                  {s.ki.split('\n').map((l, li) => (
                    <text key={li} x={x + colW / 2} y={153 + li * 12} textAnchor="middle" fontSize="8" fontWeight="600" fill="#7c3aed">{l}</text>
                  ))}
                  <Arr x1={x + colW / 2} y1={128} x2={x + colW / 2} y2={136} dashed color="#7c3aed" />
                </g>
              ) : (
                <text x={x + colW / 2} y={160} textAnchor="middle" fontSize="9" fill="#cbd5e1">—</text>
              )}

              {/* Quality Gate */}
              <rect x={x + 2} y={208} width={colW - 4} height={34} rx={4} fill="#d97706" opacity={0.06} stroke="#d97706" strokeWidth={0.8} />
              {s.gate.split('\n').map((l, li) => (
                <text key={li} x={x + colW / 2} y={222 + li * 12} textAnchor="middle" fontSize="7.5" fill="#d97706">{l}</text>
              ))}

              {/* Gate Pfeil */}
              {i < 8 && (
                <Arr x1={x + colW - 2} y1={225} x2={x + colW + gap + 2} y2={225} color="#d97706" />
              )}
            </g>
          );
        })}

        {/* 4D-Hinweis */}
        <rect x={startX + 50} y={256} width={720 - startX - 50} height={28} rx={6} fill="#2563eb" opacity={0.04} stroke="#2563eb" strokeWidth={0.8} strokeDasharray="4,3" />
        <text x={380} y={274} textAnchor="middle" fontSize="10" fontWeight="600" fill="#2563eb">4D-Prozess: D0 → D1 → D2 → D3 → D4 → D8  (D5, D6, D7 entfallen)</text>

        {/* Eskalation */}
        <rect x={startX + 50} y={288} width={300} height={6} rx={3} fill="#dc2626" opacity={0.12} />
        <text x={startX + 200} y={298} textAnchor="middle" fontSize="8" fill="#dc2626" opacity={0.6}>Eskalation bei Fristuberschreitung (mehrstufig)</text>
      </svg>
    </div>
  );
}
